import { NGXLogger } from "ngx-logger";

// Normally the NGXLogger logger gets injected into an angular component
// using Angular dependency injection. In pure functions
// (such as reducers) there is no way to use DI. So we'll
// create and export a reference here that we can let the app
// set so that the same logger is used everywhere.
export let logger: NGXLogger | any;

export function initStaticLoggerReference(loggerInstance: NGXLogger | any) {
  logger = loggerInstance;
}
